<div
  [ngStyle]="{ background: 'url(assets/images/MarsChuteBanner.png)' }"
  class="content-header"
>
  <span class="header-title">Search MARS Database</span>
</div>
<p>search works!</p>
